import { UsersDisplayItems } from 'requests/RequestUser';
import { Validator } from './Validator';
import { ReactError } from 'consts/ReactError';

export type FormErrors = {
	gid: string;
	mailaddress_1: string;
	lastname: string;
	firstname: string;
	kana_lastname: string;
	kana_firstname: string;
	sex: string;
	tel: string;
	zip: string;
	pref_cd: string;
	address_2: string;
	address_3: string;
	address_4: string;
	nickname: string;
	birthYear: string;
	birthMonth: string;
	birthDate: string;
	country: string;
};

export const initialFormErrors: FormErrors = {
	gid: '',
	mailaddress_1: '',
	lastname: '',
	firstname: '',
	kana_lastname: '',
	kana_firstname: '',
	sex: '',
	tel: '',
	zip: '',
	pref_cd: '',
	address_2: '',
	address_3: '',
	address_4: '',
	nickname: '',
	birthYear: '',
	birthMonth: '',
	birthDate: '',
	country: '',
};

export const getErrorMessage = <T>(name: string, value: T, display_item?: UsersDisplayItems): string => {
	const validator = new Validator(value);
	switch (name) {
		case 'gid':
			return validator.require().charTypeGakkenId().end();
		case 'mailaddress_1':
			return validator.require().charTypeEmail().end();
		case 'lastname':
		case 'firstname':
			return validator.require().charTypeFullWidth(ReactError.E0007).end();
		case 'kana_lastname':
		case 'kana_firstname':
			return display_item && (display_item.kana_lastname === 1 || display_item.kana_firstname === 1)
				? validator.require().charTypeFullWidthKana(ReactError.E0006).end()
				: validator.charTypeFullWidthKana(ReactError.E0006).end();
		case 'birthYear':
		case 'birthMonth':
		case 'birthDate':
			return validator.require().end();
		case 'sex':
			return display_item && display_item.sex === 1 ? validator.require().end() : '';
		case 'tel':
			return display_item && display_item.tel === 1
				? validator.require().charTypeTel().end()
				: validator.charTypeTel().end();
		case 'zip':
			return display_item && display_item.zip === 1
				? validator.require().charTypeZip().end()
				: validator.charTypeZip().end();
		case 'pref_cd':
			return display_item && display_item.pref_cd === 1 ? validator.require().end() : '';
		case 'address_2':
			return display_item && display_item.address_2 === 1
				? validator.require().charTypeFullWidth().end()
				: validator.charTypeFullWidth().end();
		case 'address_3':
			return display_item && display_item.address_3 === 1
				? validator.require().charTypeFullWidth().end()
				: validator.charTypeFullWidth().end();
		case 'address_4':
			return display_item && display_item.address_4 === 1
				? validator.require().charTypeFullWidth().end()
				: validator.charTypeFullWidth().end();
		case 'nickname':
			return display_item && display_item.nickname === 1
				? validator.require().charTypeNickName().end()
				: validator.charTypeNickName().end();
		case 'country':
			return display_item && display_item.country === 1 ? validator.require().end() : '';
		default:
			return '';
	}
};
